import { WithRef, toTimestamp } from '@principle-theorem/shared';
import {
  BaseSterilistionEquipmentDestinationEntity,
  ISterilisationEquipmentJobData,
  ISterilisationEquipmentRecordMigrationData,
} from '../../../destination/entities/sterilisation-equipment';
import {
  D4WSterilisationPack,
  SterilisationPackSourceEntity,
} from '../../source/entities/sterilisation-packs';
import { D4WSterilisationEquipmentMappingHandler } from '../mappings/sterilisation-equipment';
import { type ISterilisationEquipment } from '@principle-theorem/principle-core/interfaces';
import { TranslationMapHandler } from '../../../translation-map';
import {
  DestinationEntityRecordStatus,
  SkippedDestinationEntityRecord,
  type FailedDestinationEntityRecord,
  type IDestinationEntity,
  type IDestinationEntityRecord,
  type IPracticeMigration,
} from '@principle-theorem/practice-migrations/interfaces';

export class D4WSterilisationEquipmentDestinationEntity extends BaseSterilistionEquipmentDestinationEntity<D4WSterilisationPack> {
  sterilisationEquipmentSourceEntity = new SterilisationPackSourceEntity();
  sterilisationEquipmentCustomMapping =
    new D4WSterilisationEquipmentMappingHandler();

  override sourceEntities = {
    steriliserEquipment: new SterilisationPackSourceEntity(),
  };

  customMappings = {
    steriliserEquipmentMapping: this.sterilisationEquipmentCustomMapping,
  };

  buildMigrationData(
    _migration: WithRef<IPracticeMigration>,
    _destinationEntity: WithRef<IDestinationEntity>,
    _translationMap: TranslationMapHandler,
    data: ISterilisationEquipmentJobData<D4WSterilisationPack>
  ):
    | ISterilisationEquipmentRecordMigrationData
    | (IDestinationEntityRecord & FailedDestinationEntityRecord) {
    const sourceSteriliserEquipmentId = this.sterilisationEquipmentSourceEntity
      .getSourceRecordId(data.sourceSterilisationEquipment.data)
      .toString();
    const sourceSteriliserEquipment = data.sourceSterilisationEquipment.data;

    const equipmentRecord: ISterilisationEquipment = {
      name: sourceSteriliserEquipment.contents,
      deleted: !sourceSteriliserEquipment.isActive,
    };

    return {
      sterilisationEquipmentRecord: {
        ...equipmentRecord,
        sourceIdentifier: sourceSteriliserEquipmentId,
        createdAt: toTimestamp(),
      },
    };
  }

  buildSkippedResponse(
    data: ISterilisationEquipmentJobData<D4WSterilisationPack>
  ): IDestinationEntityRecord & SkippedDestinationEntityRecord {
    return {
      uid: data.sourceSterilisationEquipment.record.uid,
      label: data.sourceSterilisationEquipment.record.label,
      status: DestinationEntityRecordStatus.Skipped,
      sourceRef: data.sourceSterilisationEquipment.record.id,
    };
  }
}
